import {generateUUID} from "three/src/math/MathUtils";
import {Message} from "./RestApiModels/MessageModel"
import {News} from "./RestApiModels/NewsModel";

class ApiController {
    // Messages Crud
    public async SendMessage(message: Message) {
        if (!message.id) message.id = generateUUID();
        return fetch("/api/message", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(message)
        }).then(res => {
            if (!res.ok) {
                window.alert("Błąd podczas wysyłania!");
                return res.text().then(console.log);
            }
        });
    }

    public async GetMessages(): Promise<Message[] | {error: true, raw: any}> {
        return fetch("/api/messages", {
            method: "GET",
            headers: { "Content-Type": "application/json" }
        })
            .then(async res => {
                if (!res.ok) {
                    window.alert("Błąd podczas pobierania wiadomości!");
                    const raw = await res.text();
                    console.log(raw);
                    return {error: true, raw};
                }
                try {
                    return await res.json();
                } catch (err) {
                    window.alert("Błąd parsowania obiektu");
                    return {error: true, raw: "Błąd parsowania JSON"};
                }
            })
            .catch(err => {
                window.alert("Błąd sieci podczas pobierania wiadomości!");
                console.log(err);
                return {error: true, raw: err};
            });
    }

    // News Crud
    public async AddNews(news: News) {
        if (!news.id) news.id = generateUUID();

        console.log(news);
        return fetch("/api/news", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(news)
        }).then(res => {
            if (!res.ok) {
                window.alert("Błąd podczas dodawania wpisu w aktualnościach.");
                return res.text().then(console.log);
            }
        });
    }

    public async GetNews(id: any): Promise<News | undefined> {
        if (!id) throw "Id nie może być nullem";
        return fetch(`/api/news/${id}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" }
        })
            .then(async res => {
                if (!res.ok) {
                    window.alert("Nie znaleziono wpisu w bazie danych lub wystąpił niespodziewany błąd. Skontaktuj się z administratorem strony");
                    console.log(await res.text());
                    return undefined;
                }
                return res.json();
            });
    }

    public async GetNewses(): Promise<News[] | {error: true, raw: any}> {
        return fetch("/api/newses", {
            method: "GET",
            headers: { "Content-Type": "application/json" }
        })
            .then(async res => {
                if (!res.ok) {
                    const raw = await res.text();
                    window.alert(`Nie znaleziono wpisu w bazie danych lub wystąpił niespodziewany błąd. Skontaktuj się z administratorem strony ERROR: ${raw}`);
                    return {error: true, raw};
                }
                try {
                    return await res.json();
                } catch (err) {
                    window.alert("Błąd parsowania obiektu");
                    // Nie próbujemy czytać body drugi raz!
                    return {error: true, raw: "Błąd parsowania JSON (nieprawidłowy format odpowiedzi z serwera)"};
                }
            })
            .catch(err => {
                window.alert("Błąd sieci podczas pobierania aktualności!");
                console.log(err);
                return {error: true, raw: err};
            });
    }

    public async DeleteNews(id: any) {
        return fetch(`/api/news/${id}`, {
            method: "DELETE",
            headers: { "Content-Type": "application/json" }
        }).then(async res => {
            if (!res.ok) {
                window.alert("Błąd podczas usuwania wpisu w bazie danych");
                console.log(await res.text());
            }
        });
    }

    public async UpdateNews(news: News) {
        return fetch(`/api/news/`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(news)
        }).then(async res => {
            if (!res.ok) {
                window.alert("Błąd podczas aktualizacji wpisu w bazie danych");
                console.log(await res.text());
                return undefined;
            }
            return this.GetNews(news.id);
        });
    }
}

export { ApiController };
